import AfipProvider from "@/modules/afip/providers/AfipProvider";

export default {
    data() {
        return {
            serverStatus: null,
            puntosVenta: null,
            tiposComprobantes: null,
            tipoConceptos: null,
            tipoDocumentos: null,
            tipoAlicuotas: null,
            tipoMonedas: null
        }
    },
    methods: {
        getServerStatus() {
            AfipProvider.getServerStatus()
                .then(r => {
                    this.serverStatus = r.data.getServerStatus
                })
        },
        getPuntosVenta() {
            AfipProvider.getPuntosVenta()
                .then(r => {
                    this.puntosVenta = r.data.getPuntosVenta
                })
        },
        getTipoComprobantes() {
            AfipProvider.getTipoComprobantes()
                .then(r => {
                    this.tiposComprobantes = r.data.getTipoComprobantes
                })
        },
        getTipoConceptos() {
            AfipProvider.getTipoConceptos()
                .then(r => {
                    this.tipoConceptos = r.data.getTipoConceptos
                })
        },
        getTipoDocumentos() {
            AfipProvider.getTipoDocumentos()
                .then(r => {
                    this.tipoDocumentos = r.data.getTipoDocumentos
                })
        },
        getTipoAlicuotas() {
            AfipProvider.getTipoAlicuotas()
                .then(r => {
                    this.tipoAlicuotas = r.data.getTipoAlicuotas
                })
        },
        getTipoMonedas() {
            AfipProvider.getTipoMonedas()
                .then(r => {
                    this.tipoMonedas = r.data.getTipoMonedas
                })
        }
    }
}
